module.exports = __webpack_public_path__ + "img/22.d3f9bb23.jpeg";